<template>
<div id="calculator">
  <v-app id="calculatorapp">
    <v-row justify="center">
      <v-dialog v-model="loading" fullscreen full-width>
        <v-container fluid fill-height style="background-color: rgba(255,255,255, 0.7);">
          <v-layout justify-center align-center>
            <v-progress-circular
              indeterminate
              color="primary">
            </v-progress-circular>
          </v-layout>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialog" :content-class ="this.mycalculation_already_opened ? 'calculator-dialog calculator-dialog-full' : 'calculator-dialog'">
        <v-card>
          <v-card-title>
            <span class="headline">{{$t('simulation_connection')}}</span>
            <v-btn text icon large color="primary" class="info-close-btn" @click="closeDialog">
              <v-icon>mdi-close-circle-outline</v-icon>              
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" >
                <p>{{$t('calculate_simulation_connection')}}</p>
              </v-col>
            </v-row>
            <v-row justify="center" class="p-rows">
              <v-col cols="12"  :class = '[{"col-md-4": this.mycalculation_already_opened}]' >
                <v-expansion-panels 
                  flat 
                  accordion
                  v-model="panels"
                  class="calculator-panels elevation-0"> 
                  <!-- MY ADDRESS START -->
                  <!-- <v-expansion-panel  :disabled="myaddress" class="address">
                    <v-expansion-panel-header disable-icon-rotate>
                      <v-row no-gutters>
                        <v-col cols="12" md="5" class="cat-title">{{$t('address')}}</v-col>
                        <v-col  cols="12" md="7" class="cat-value">{{ this.$store.searchedAddressText }}</v-col>
                      </v-row>
                      <template v-slot:actions>
                        <v-icon color="primary">mdi-pencil</v-icon>
                      </template>
                     
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row >
                        <v-col  cols="12" class="minimap">
                          <img @click="closeDialog" :src=this.staticURL>
                          <div class="minipointer" @click="closeDialog"><v-img  src="@/assets/images/marker.svg"  height="30" contain></v-img></div>
                        </v-col>
                      </v-row>
                      <v-row > 
                        <v-col cols ="12">
                          <v-btn color="primary" rounded depressed large class="info-submit-btn" @click="openMyBuilding" v-if="!calculated" >{{$t('start_simulation')}}</v-btn>

                        <p class="calculator-disclaimer">En saisissant vos données, vous autorisez Groupe E Celsius à les utiliser afin de garantir une expérience utilisateur optimale.</p>
                      </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel> -->
                  <!-- MY ADDRESS END --> 
                  <!-- MY BUILDING SIZE START -->
                  <v-expansion-panel  v-if="this.mybuilding_visible"
                    :disabled="mybuilding" class="mybuilding" id="mybuilding">
                     <v-expansion-panel-header disable-icon-rotate>
                      <v-row no-gutters>
                        <v-col cols="12" md="5" class="cat-title">{{$t('building_size')}}
                        </v-col>
                        <v-col  cols="12"  md="7" class="cat-value">{{ this.mybuilding_text}}</v-col>
                      </v-row>
                      <template v-slot:actions>
                        <v-icon color="primary">mdi-pencil</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>                     
                      <v-row>
                        <v-col cols="4">
                          <div class="choice" v-bind:class="{ active : isHouse}" v-on:click="onBuildingSize('house')">
                            <img src="@/assets/images/buttons/maison.svg"/> <span>{{ $t('house') }}</span>
                          </div>
                        </v-col>
                        <v-col cols="4">
                          <div class="choice" v-bind:class="{ active : isBuilding}" v-on:click="onBuildingSize('building')">
                            <img src="@/assets/images/buttons/immeuble.svg"/> <span>{{ $t('building') }}</span>
                          </div>
                        </v-col>
                        <v-col cols="4">
                          <div class="choice" v-bind:class="{ active : isCompany}" v-on:click="onBuildingSize('company')">
                            <img src="@/assets/images/buttons/entreprise.svg"/> <span>{{ $t('company') }}</span>
                          </div>
                        </v-col>
                      </v-row>      
                      <v-row>
                        <v-col cols ="12">
                          <v-btn color="primary" :disabled="mybuilding_button" rounded depressed large class="info-submit-btn" @click="openMyBuildingType" >{{$t('next_step')}}</v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                  <!-- MY BUILDING SIZE END-->
                  <!-- MY BUILDING TYPE START -->
                  <v-expansion-panel  v-if="this.mybuilding_type_visible"
                    :disabled="mybuilding_type" class="mybuildingtype" id="mybuildingtype">
                     <v-expansion-panel-header disable-icon-rotate>
                       <v-row no-gutters>
                          <v-col cols="12" md="5" class="cat-title">{{ $t('building_type') }}
                          </v-col>
                          <v-col  cols="12" md="7" class="cat-value">{{ this.mybuilding_type_text}}</v-col>
                       </v-row>
                      <template v-slot:actions>
                        <v-icon color="primary">mdi-pencil</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row >
                        <v-col cols="6">
                        <v-radio-group v-model="building_type">
                          <v-radio v-bind:label="$t('new')" color="primary" value="new" @click.native="mybuilding_type_event"></v-radio>
                        </v-radio-group></v-col><v-col cols="6">
                        <v-radio-group v-model="building_type">
                          <v-radio v-bind:label="$t('existing')" color="primary" value="existing" @click.native="mybuilding_type_event"></v-radio>
                        </v-radio-group></v-col>
                      </v-row> 
                      <v-row v-if="building_type=='existing'">
                        <v-col cols="12">
                          <v-text-field
                            v-bind:label="$t('building_year')"
                            v-bind:placeholder="$t('building_year_hint')"                            
                            outlined
                            v-model="building_date"
                            @input="mybuilding_type_event"
                            type="number">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols ="12">
                          <v-btn color="primary" :disabled="mybuilding_type_button" rounded depressed large class="info-submit-btn" @click="openMyBuildingRenovation" >{{$t('next_step')}}</v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                  <!-- MY BUILDING TYPE END-->
                  
                  <!-- MY BUILDING RENOVATION START -->
                  <v-expansion-panel v-if="this.mybuilding_renovation_visible"
                    :disabled="mybuilding_renovation" class="mybuildingrenovation" id="mybuildingrenovation">
                     <v-expansion-panel-header disable-icon-rotate>
                       <v-row no-gutters>
                          <v-col cols="12" md="5" class="cat-title">{{$t('renovation')}}
                          </v-col>
                          <v-col cols="12" md="7" class="cat-value">{{ this.mybuilding_renovation_text}}</v-col>
                       </v-row>
                      <template v-slot:actions>
                        <v-icon color="primary">mdi-pencil</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                       <v-row>
                        <v-col cols="12">
                          <span class="error--text" v-if="this.mybuilding_renovation_error">{{this.mybuilding_renovation_error}}</span>
                          <v-switch
                            v-model="renovation"
                            :label="$t('yes')" color="primary"
                            @click.native="mybuilding_event_renovation_delayed"
                          ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row >
                      <v-col cols="12" v-if="renovation">
                        <v-text-field
                          :label="$t('renovation_year')"
                          :placeholder="$t('renovation_year_hint')"                            
                          outlined
                          v-model="renovation_date"
                          @change="mybuilding_event_renovation"
                          @input="mybuilding_event_renovation"
                          type="number">
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="renovation">
                      <v-col cols="12">
                        <v-select
                          :items="renovation_types"
                          :label="$t('renovation_type')"
                          item-text="value"
                          item-value="id"
                          outlined
                          v-model="renovation_type"
                          @change="mybuilding_event_renovation"
                        ></v-select>
                      </v-col>
                    </v-row>
                      <v-row>
                        <v-col cols ="12">
                          <v-btn color="primary" :disabled="mybuilding_renovation_button" rounded depressed large class="info-submit-btn" @click="openMyBuildingArea" >{{$t('next_step')}}</v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                  <!-- MY BUILDING RENOVATION END-->
                  <!-- MY BUILDING AREA START -->
                  <v-expansion-panel  v-if="this.mybuilding_area_visible"
                    :disabled="mybuilding_area" class="mybuildingarea" id="mybuildingarea">
                     <v-expansion-panel-header disable-icon-rotate>
                       <v-row no-gutters>
                          <v-col cols="12" md="5" class="cat-title">{{$t('heating_area')}}
                          </v-col>
                          <v-col  cols="12" md="7" class="cat-value">{{ this.mybuilding_area_text}}</v-col>
                       </v-row>
                      <template v-slot:actions>
                        <v-icon color="primary">mdi-pencil</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                       <v-row>
                        <v-col cols="9">
                          <v-text-field
                            :label="$t('heating_area')"
                            :placeholder="$t('heating_area_hint')"                            
                            outlined
                            v-model="living_area"
                            @change="mybuilding_event_area"
                            @input="mybuilding_event_area"
                            @keydown.enter="openMyHeatingType"
                            type="number">
                          </v-text-field>
                        </v-col>
                        <v-col cols="3">

                          <v-tooltip bottom content-class="mytooltip">
                                <template v-slot:activator="{ on }">
                                  <v-btn class="mytooltipbtn"  v-on="on" fab depressed  color="primary">
                                    <v-icon dark>mdi-help</v-icon>
                                  </v-btn>
                                </template>
                                <span >{{$t('heating_area_tooltip')}}</span>
                              </v-tooltip>
                          
                          
                        </v-col>
                    </v-row>
                      <v-row>
                        <v-col cols ="12">
                          <v-btn color="primary" :disabled="mybuilding_area_button" rounded depressed large class="info-submit-btn" @click="openMyHeatingType" >{{$t('next_step')}}</v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                  <!-- MY BUILDING AREA END-->
                    <!-- MY BUILDING HEATING TYPE START -->
                  <v-expansion-panel  v-if="this.mybuilding_heating_type_visible"
                    :disabled="mybuilding_heating_type" class="mybuildingheatingtype" id="mybuildingheatingtype">
                     <v-expansion-panel-header disable-icon-rotate>
                      <v-row no-gutters>
                        <v-col cols="12" md="5" class="cat-title">{{$t('heating_type')}}
                        </v-col>
                        <v-col  cols="12" md="7" class="cat-value">{{ this.mybuilding_heating_type_text}}</v-col>
                      </v-row>
                      <template v-slot:actions>
                        <v-icon color="primary">mdi-pencil</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>                      
                      <v-row>
                        <v-col cols="6" md="3">
                          <div class="choice" v-bind:class="{ active : heating_type==1}" v-on:click="onHeatingType(1)">
                            <img src="@/assets/images/buttons/mazout.svg"/> <span>{{ $t('oil') }}</span>
                          </div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="choice" v-bind:class="{ active : heating_type==2}" v-on:click="onHeatingType(2)">
                            <img src="@/assets/images/buttons/gaz.svg"/> <span>{{ $t('gaz') }}</span>
                          </div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="choice" v-bind:class="{ active : heating_type==3}" v-on:click="onHeatingType(3)">
                            <img src="@/assets/images/buttons/bois.svg"/> <span>{{ $t('wood') }}</span>
                          </div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="choice" v-bind:class="{ active : heating_type==4}" v-on:click="onHeatingType(4)">
                            <img src="@/assets/images/buttons/electricite.svg"/> <span>{{ $t('electricity') }}</span>
                          </div>
                        </v-col>
                      </v-row>      
                      <v-row>
                        <v-col cols ="12">
                          <v-btn color="primary" :disabled="mybuilding_heating_type_button" rounded depressed large class="info-submit-btn" @click="openMyBuildingBoiler" >{{$t('next_step')}}</v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                  <!-- MY BUILDING HEATING TYPE END-->
                    <!-- MY BUILDING BOILER START -->
                  <v-expansion-panel   v-if="this.mybuilding_boiler_visible"
                    :disabled="mybuilding_boiler" class="mybuildingboiler" id="mybuildingboiler">
                     <v-expansion-panel-header disable-icon-rotate>
                      <v-row no-gutters>
                        <v-col cols="12" md="5" class="cat-title">{{$t('boiler')}}
                        </v-col>
                        <v-col  cols="12" md="7" class="cat-value">{{ this.mybuilding_boiler_text}}</v-col>
                      </v-row>
                      <template v-slot:actions>
                        <v-icon color="primary">mdi-pencil</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>                      
                      <v-row>
                        <v-col cols="6">
                          <div class="choice" v-bind:class="{ active : this.boiler_type==1}" v-on:click="onBoilerType(1)">
                            <img src="@/assets/images/buttons/chauffe-eau-electrique.svg"/> <span>{{ $t('electric') }}</span>
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="choice" v-bind:class="{ active : this.boiler_type==2}" v-on:click="onBoilerType(2)">
                            <img src="@/assets/images/buttons/chauffe-eau-central.svg"/> <span>{{ $t('with_heating') }}</span>
                          </div>
                        </v-col>
                      </v-row>      
                      <v-row>
                        <v-col cols ="12">
                          <v-btn color="primary" :disabled="mybuilding_boiler_button" rounded depressed large class="info-submit-btn" @click="openMyCalculation" v-if="this.building_type == 'new'">{{ $t('calculate') }}</v-btn>
                          <v-btn color="primary" :disabled="mybuilding_boiler_button" rounded depressed large class="info-submit-btn" @click="openMyBuildingConsumption"  v-if="this.building_type == 'existing'">{{$t('next_step') }}</v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                  <!-- MY BUILDING BOILER END-->
                    <!-- MY BUILDING CONSUMPTION START -->
                  <v-expansion-panel  v-if="this.mybuilding_consumption_visible"
                    :disabled="mybuilding_consumption" class="mybuilding_consumption" id="mybuildingconsumption">
                     <v-expansion-panel-header disable-icon-rotate>
                      <v-row no-gutters>
                        <v-col cols="12" md="5" class="cat-title">{{$t('consumption')}}
                        </v-col>
                        <v-col  cols="12" md="7" class="cat-value">{{ this.mybuilding_consumption_text}}</v-col>
                      </v-row>
                      <template v-slot:actions>
                        <v-icon color="primary">mdi-pencil</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>                      
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            :label="$t('heating_unit_value_label')"
                            :placeholder="$t('heating_unit_value_hint')"                            
                            outlined
                            v-model="current_consumption_value"
                            @click.native="myconsumption_event"
                            @change="myconsumption_event"
                            @input="myconsumption_event"
                            @keydown.enter="openMyCalculation"
                            persistent-hint
                            :hint="$t('estimated_heating_unit_value')+': '+this.estimated_consumption_value_formatted"
                            type="number">
                          </v-text-field>
                        </v-col>
                      </v-row>      
                      <v-row>
                        <v-col cols ="12">
                          <v-btn color="primary" :disabled="mybuilding_consumption_button" rounded depressed large class="info-submit-btn" @click="openMyCalculation">{{ $t('calculate') }}</v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                  <!-- MY BUILDING CONSUMPTION END-->
                </v-expansion-panels>
                      <div class="tinyinfo">{{$t('law')}}</div>
              </v-col>
            <!-- MY CALCULATION COL-->
              <v-col cols="12" md="8" class="calculation" v-if="this.mycalculation_already_opened">            
                  <v-row no-gutters>
                    <v-col cols="12" class="category-caption sim-title">
                      <b>{{$t('simulation_data')}}</b>
                      <v-tooltip bottom content-class="mytooltip">
                            <template v-slot:activator="{ on }">
                              <v-btn class="mytooltipbtn"  v-on="on" fab depressed  color="primary">
                                <v-icon dark>mdi-help</v-icon>
                              </v-btn>
                            </template>
                            <span >{{$t('calculation_hint')}}</span>
                          </v-tooltip>

                    </v-col>
                  </v-row>
                  <v-row no-gutters>   
                    <v-col cols="12" sm="5" class="pb-2 pt-1">  
                      <span class="gray">{{$t('address')}}</span>
                    </v-col>
                    <v-col cols="12" sm="7" class="pb-2 pt-1">  
                      <span><b>{{this.$store.searchedAddressText}}</b></span>
                    </v-col>  
                  </v-row>                      
                  <v-row  no-gutters>
                    <v-col cols="12" sm="5" class="pb-2 pt-1">  
                      <span class="gray">{{$t('estimated_power')}}</span>
                    </v-col>
                    <v-col cols="12" sm="7" class="pb-2 pt-1">  
                      <span><b>{{ this.power }} {{$t('kw')}}</b></span>
                    </v-col>  
                  </v-row>                  
                  <v-row  no-gutters>
                    <v-col cols="12" sm="5" class="pb-2 pt-1">  
                      <span class="gray">{{$t('estimated_annual_consumption')}}</span>
                    </v-col>
                    <v-col cols="12" sm="7" class="pb-2 pt-1">  
                      <span><b>{{ this.total_av_consumption }} {{ $t('kwh_year')}}</b></span>
                      <span class="disclaimer" v-if="this.mybuilding_consumption_from_client"> * {{$t('client_value')}}</span>
                    </v-col>  
                  </v-row>
                  
                  <v-row no-gutters  class="mt-4">
                    <v-col cols="12" class="category-caption">
                      <b>{{$t('investment')}}</b>
                    </v-col>
                    <v-col cols="12">
                      <v-simple-table>
                            <tbody>
                              <tr>
                                <td>{{$t('connection_contribution')}}</td>
                                <td class="text-right">{{ this.connection_contribution }} {{$t('chf')}}</td>
                              </tr>
                              <tr v-if="this.promotion != 0">
                                <td style="color:#E28E2A">{{$t('promotion')}}</td>
                                <td style="color:#E28E2A"  class="text-right">- {{ this.promotion }} {{$t('chf')}}</td>
                              </tr>
                              <tr v-if="this.sponsoring != 0">
                                <td>{{$t('sponsoring')}}
                                <v-tooltip bottom content-class="mytooltip">
                                    <template v-slot:activator="{ on }">
                                      <v-btn class="mytooltipbtn2"  v-on="on" fab depressed  color="primary">
                                        <v-icon dark>mdi-help</v-icon>
                                      </v-btn>
                                    </template>
                                  <span >{{ $t('sponsoring_hint') }}</span>
                                </v-tooltip>
                                </td>
                                <td class="text-right">- {{ this.sponsoring }} {{$t('chf')}}</td>
                              </tr>
                              <tr>
                                <td><b>{{$t('total')}}</b></td>
                                <td class="text-right"><b>{{ this.total_connection_costs }} {{$t('chf')}}</b></td>
                              </tr>
                            </tbody>
                        </v-simple-table>
                        
                    </v-col>
                  </v-row>
                  <v-row no-gutters   class="mt-4">
                    <v-col cols="12" class="category-caption">
                        <b>{{$t('products')}}</b>
                    </v-col>
                    <v-col cols="12">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <img v-if="this.$store.lang=='fr'" src="@/assets/images/logo-chaleur-75-fr.svg" style="max-width:120px; padding-top:20px;">
                          <img v-if="this.$store.lang=='de'" src="@/assets/images/logo-chaleur-75-de.svg" style="max-width:120px; padding-top:20px;">
                        </v-col>
                          <v-col cols="12" class="mt-1">
                          <b>{{$t('heating_75_text1')}}</b><br>
                          {{$t('heating_75_text2')}} <br>
                          </v-col>
                        <v-col  md="3"  sm="5" class="mt-1">
                          <br>
                          <div  class="piechart"><pie-chart :data="chartData" :options="chartOptions"></pie-chart></div>
                          <br><br>
                        </v-col>
                        <v-col  md="9"  sm="7" class="mt-1">
                          <br>
                        <v-row no-gutters style="margin-bottom:10px">
                          <v-col cols="12" sm="6">{{$t('heating_price')}}</v-col>
                          <v-col cols="12" sm="6">{{ this.price_75 }} {{$t('ct/kWh/an')}} 
                            <v-tooltip bottom content-class="mytooltip">
                              <template v-slot:activator="{ on }">
                                <v-btn class="mytooltipbtn2"  v-on="on" fab depressed  color="primary">
                                  <v-icon dark>mdi-help</v-icon>
                                </v-btn>
                              </template>
                            <span >{{$t('heating_price_explanation')}}</span>
                          </v-tooltip>
                          </v-col>
                        </v-row> 
                        <v-row no-gutters style="margin-bottom:10px">
                          <v-col cols="12" sm="6">{{$t('power_price')}}</v-col>
                          <v-col cols="12" sm="6">{{ this.power_contribution }} {{$t('CHF/kW/an')}}
                              <v-tooltip bottom content-class="mytooltip">
                                    <template v-slot:activator="{ on }">
                                      <v-btn class="mytooltipbtn2"  v-on="on" fab depressed  color="primary">
                                        <v-icon dark>mdi-help</v-icon>
                                      </v-btn>
                                    </template>
                                  <span >{{$t('power_price_explanation')}}</span>
                                </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col cols="12" sm="6">{{$t('annual_estimated_costs')}}</v-col>
                          <v-col cols="12" sm="6">{{ this.annual_estimated_cost_75 }} {{$t('CHF/an')}}
                          </v-col>
                        </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <img v-if="this.$store.lang=='fr'" src="@/assets/images/logo-chaleur-80-fr.svg" style="max-width:120px">
                          <img v-if="this.$store.lang=='de'" src="@/assets/images/logo-chaleur-80-de.svg" style="max-width:120px">
                        </v-col>
                          <v-col cols="12" class="mt-1">
                          <b>{{$t('heating_80_text1')}}</b><br>
                          {{$t('heating_80_text2')}} <br>
                          </v-col>
                        <v-col  md="3"  sm="5" class="mt-1">
                          <br>
                          <div class="piechart"><pie-chart :data="chartData2" :options="chartOptions"></pie-chart></div>
                          <br><br>
                          </v-col>
                        <v-col  md="9"  sm="7" class="mt-1">
                          <br>
                        <v-row no-gutters style="margin-bottom:10px">
                          <v-col cols="12" sm="6">{{$t('heating_price')}}</v-col>
                          <v-col cols="12" sm="6">{{ this.price_80 }} {{$t('ct/kWh/an')}}
                            <v-tooltip bottom content-class="mytooltip">
                              <template v-slot:activator="{ on }">
                                <v-btn class="mytooltipbtn2"  v-on="on" fab depressed  color="primary">
                                  <v-icon dark>mdi-help</v-icon>
                                </v-btn>
                              </template>
                            <span >{{$t('heating_price_explanation')}}</span>
                          </v-tooltip>
                          </v-col>
                        </v-row> 
                        <v-row no-gutters style="margin-bottom:10px">
                          <v-col cols="12" sm="6">{{$t('power_price')}}</v-col>
                          <v-col cols="12" sm="6">{{ this.power_contribution }} {{$t('CHF/kW/an')}}
                              <v-tooltip bottom content-class="mytooltip">
                                    <template v-slot:activator="{ on }">
                                      <v-btn class="mytooltipbtn2"  v-on="on" fab depressed  color="primary">
                                        <v-icon dark>mdi-help</v-icon>
                                      </v-btn>
                                    </template>
                                  <span >{{$t('power_price_explanation')}}</span>
                                </v-tooltip></v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col cols="12" sm="6">{{$t('annual_estimated_costs')}}</v-col>
                          <v-col cols="12" sm="6">{{ this.annual_estimated_cost_80 }} {{$t('CHF/an')}}
                          </v-col>
                        </v-row>
                        </v-col>
                      </v-row>

                    </v-col>
                    <v-col cols="12">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <img v-if="this.$store.lang=='fr'" src="@/assets/images/logo-chaleur-90-fr.svg" style="max-width:120px">
                          <img v-if="this.$store.lang=='de'" src="@/assets/images/logo-chaleur-90-de.svg" style="max-width:120px">
                        </v-col>
                          <v-col cols="12" class="mt-1">
                          <b>{{$t('heating_90_text1')}}</b><br>
                          {{$t('heating_90_text2')}} <br>
                          </v-col>
                        <v-col  md="3"  sm="5" class="mt-1">
                          <br>
                          <div class="piechart"><pie-chart :data="chartData3" :options="chartOptions"></pie-chart></div>
                          <br><br>
                          </v-col>
                        <v-col  md="9"  sm="7" class="mt-1">
                          <br>
                        <v-row no-gutters style="margin-bottom:10px">
                          <v-col cols="12" sm="6">{{$t('heating_price')}}</v-col>
                          <v-col cols="12" sm="6">{{ this.price_90 }} {{$t('ct/kWh/an')}}
                            <v-tooltip bottom content-class="mytooltip">
                              <template v-slot:activator="{ on }">
                                <v-btn class="mytooltipbtn2"  v-on="on" fab depressed  color="primary">
                                  <v-icon dark>mdi-help</v-icon>
                                </v-btn>
                              </template>
                            <span >{{$t('heating_price_explanation')}}</span>
                          </v-tooltip>
                          </v-col>
                        </v-row> 
                        <v-row no-gutters style="margin-bottom:10px">
                          <v-col cols="12" sm="6">{{$t('power_price')}}</v-col>
                          <v-col cols="12" sm="6">{{ this.power_contribution }} {{$t('CHF/kW/an')}}
                              <v-tooltip bottom content-class="mytooltip">
                                    <template v-slot:activator="{ on }">
                                      <v-btn class="mytooltipbtn2"  v-on="on" fab depressed  color="primary">
                                        <v-icon dark>mdi-help</v-icon>
                                      </v-btn>
                                    </template>
                                  <span >{{$t('power_price_explanation')}}</span>
                                </v-tooltip></v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col cols="12" sm="6">{{$t('annual_estimated_costs')}}</v-col>
                          <v-col cols="12" sm="6">{{ this.annual_estimated_cost_90 }} {{$t('CHF/an')}}
                          </v-col>
                        </v-row>
                        </v-col>
                      </v-row>

                    </v-col>
                    <v-col cols="12">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <img v-if="this.$store.lang=='fr'" src="@/assets/images/logo-chaleur-100-fr.svg" style="max-width:120px">
                          <img v-if="this.$store.lang=='de'" src="@/assets/images/logo-chaleur-100-de.svg" style="max-width:120px">
                        </v-col>
                          <v-col cols="12" class="mt-1">
                          <b>{{$t('heating_100_text1')}}</b><br>
                          {{$t('heating_100_text2')}} <br>
                          </v-col>
                        <v-col  md="3"  sm="5" class="mt-1">
                          <br>
                          <div class="piechart"><pie-chart :data="chartData4" :options="chartOptions"></pie-chart></div>
                          <br><br>
                          </v-col>
                        <v-col  md="9"  sm="7" class="mt-1">
                          <br>
                        <v-row no-gutters style="margin-bottom:10px">
                          <v-col cols="12" sm="6">{{$t('heating_price')}}</v-col>
                          <v-col cols="12" sm="6">{{ this.price_100 }} {{$t('ct/kWh/an')}}
                            <v-tooltip bottom content-class="mytooltip">
                              <template v-slot:activator="{ on }">
                                <v-btn class="mytooltipbtn2"  v-on="on" fab depressed  color="primary">
                                  <v-icon dark>mdi-help</v-icon>
                                </v-btn>
                              </template>
                            <span >{{$t('heating_price_explanation')}}</span>
                          </v-tooltip>
                          </v-col>
                        </v-row> 
                        <v-row no-gutters style="margin-bottom:10px">
                          <v-col cols="12" sm="6">{{$t('power_price')}}</v-col>
                          <v-col cols="12" sm="6">{{ this.power_contribution }} {{$t('CHF/kW/an')}}
                              <v-tooltip bottom content-class="mytooltip">
                                    <template v-slot:activator="{ on }">
                                      <v-btn class="mytooltipbtn2"  v-on="on" fab depressed  color="primary">
                                        <v-icon dark>mdi-help</v-icon>
                                      </v-btn>
                                    </template>
                                  <span >{{$t('power_price_explanation')}}</span>
                                </v-tooltip></v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col cols="12" sm="6">{{$t('annual_estimated_costs')}}</v-col>
                          <v-col cols="12" sm="6">{{ this.annual_estimated_cost_100 }} {{$t('CHF/an')}}
                          </v-col>
                        </v-row>
                        </v-col>
                      </v-row>

                    </v-col>
                  </v-row>
                  <v-row  no-gutters >
                    <v-col cols="12" md="12">
                      <v-row v-if="this.showco2"  no-gutters>
                        <v-col cols="12" class="category-caption">
                            <b> {{$t("co2_spare")}}</b>
                        </v-col>
                        <v-col cols="12" class="mt-1">
                            <div><b><span   style="color:#2CA737">{{ this.c02_sparing }} {{$t("co2_sparing_unit")}}</span></b></div>
                            <span style="color:#2CA737"> </span>
                        
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="12"> <br> <br></v-col>
                    <v-col cols="12" md="12">
                      <v-row  v-if=" this.showmaintenance" no-gutters >
                        <v-col cols="12" class="category-caption">
                            <b>{{$t("maintenance_spare")}}</b>
                        </v-col>
                        <v-col cols="12">
                          <v-simple-table>
                            <tbody>
                              <tr>
                                <td>{{$t("maintenance_cost")}} {{$t("CAD")}}</td>
                                <td class="text-right">0 {{$t('CHF/an')}}</td>
                              </tr>
                              <tr>
                                <td>{{$t("maintenance_cost")}} {{this.mybuilding_heating_type_text}}</td>
                                <td class="text-right">{{ this.saving_maintenance_costs }} {{$t('CHF/an')}}</td>
                              </tr>
                              <tr>
                                <td style="color:#2CA737"><b>{{$t("spare")}}</b></td>
                                <td class="text-right" style="color:#2CA737"><b>- {{ this.saving_maintenance_costs }} {{$t('CHF/an')}}</b></td>
                              </tr>
                            </tbody>
                        </v-simple-table>    <br>                         
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row  no-gutters >
                    <v-col cols="12">
                      <span>{{$t('disclaimer')}}</span><br><br>

                    </v-col>
                  </v-row>       
                  <v-row  no-gutters >
                    <v-col cols="12" md="5">
                      <v-btn color="primary"  rounded depressed large class="info-submit-btn" :href="this.pdf_url" target="_blank">{{$t('simulation_pdf')}}</v-btn>
                    </v-col>
                    <v-col cols="12" md="2"><br></v-col>
                    <v-col cols="12" md="5" >
                      <v-btn color="primary" rounded depressed large class="info-submit-btn" @click="showQuoteRequestDialog" >{{$t('ask_detailed_quote')}}</v-btn>
                    </v-col>
                  </v-row>              
                  <!-- MY CALCULATION END-->
              </v-col>
            </v-row>             
          </v-card-text>
        </v-card>

      </v-dialog>
    </v-row>
  </v-app>
</div>
</template>

<script>
import axios from 'axios'
import PieChart from "../PieChart.js"
// import BarChart from "../BarChart.js"
// import { Doughnut } from 'vue-chartjs'
export default {
  name: 'Calculator',
  components: {
    PieChart,
    // BarChart
  },
  data () {
    return {
      chartOptions: {
        hoverBorderWidth: 20
      },
      chartData: {
        hoverBorderWidth: 10,
        labels: [this.$t('75_renewable'), this.$t('25_conventional')],
        legend:{
          display:false

        },

        datasets: [
          {
            label: "Data One",
            backgroundColor: ["#2CA737", "#C1C1C1"],
            data: [75, 25]
          }
        ]
      },
      chartData2: {
        hoverBorderWidth: 10,
        labels: [this.$t('80_renewable'), this.$t('20_conventional')],
        datasets: [
          {
            label: "Data One",
            backgroundColor: ["#2CA737", "#C1C1C1"],
            data: [80,20]
          }
        ]
      },
      chartData3: {
        hoverBorderWidth: 10,
        labels: [this.$t('90_renewable'), this.$t('10_conventional')],
        datasets: [
          {
            label: "Data One",
            backgroundColor: ["#2CA737", "#C1C1C1"],
            data: [90,10]
          }
        ]
      },
      chartData4: {
        hoverBorderWidth: 10,
        labels: [this.$t('100_renewable')],
        datasets: [
          {
            label: "Data One",
            backgroundColor: ["#2CA737", "#C1C1C1"],
            data: [100]
          }
        ]
      },
      // chartData3: {
      //   hoverBorderWidth: 10,
      //   labels: [this.$t('cad'),this.$t('oil')],
      //   datasets: [
      //     {
      //       label: "",
      //       backgroundColor: ["#C1C1C1" ],
      //       data: [80,100]
      //     },
      //     {
      //       label: "",
      //       backgroundColor: ["#72A62D" ],
      //       data: [20,0]
      //     },
      //   ]
      // },
      chartDataCO2: {
        hoverBorderWidth: 10,
        labels: [this.$t('sparing_co2_year')],
        datasets: [
          {
            label: "Data One",
            backgroundColor: ["#72A62D", "#C1C1C1"],
            data: [4172,6325]
          }
        ]
      },
      loading: false,
      dialog: false,
      myaddress: false,
      myaddress_status: '',
      mybuilding: true,
      building_size: '',
      isHouse: false,
      isBuilding: false,
      isCompany: false,
      sizeNotChoosen: false,
      mybuilding_button:true,
      mybuilding_text:'',
      mybuilding_visible:false,

      mybuilding_type: false,
      building_type: '',
      mybuilding_type_button:true,
      mybuilding_type_text:'',
      building_date:null,
      mybuilding_type_visible:false,

      mybuilding_renovation_text: '',
      mybuilding_renovation_button:true,
      mybuilding_renovation: false,
      mybuilding_renovation_error: '',
      renovation: false,
      renovation_date: null,
      renovation_type:'',
      renovation_types:[  { id:0, value:this.$t('windows'), factor:-0.13},
        { id:1, value:this.$t('windows_wall'), factor:-0.38},
        { id:2, value:this.$t('walls'), factor:-0.25},
        { id:3, value:this.$t('roof'), factor:-0.17},
        { id:4, value:this.$t('roof_windows'), factor:-0.30},
        { id:5, value:this.$t('roof_windows_wall'), factor:-0.55},
        { id:6, value:this.$t('roofs_wall'), factor:-0.42},
      ],
      mybuilding_renovation_visible:false,

      mybuilding_area: false,
      mybuilding_area_button:true,
      mybuilding_area_text:'',
      living_area: null,
      mybuilding_area_visible:false,

      heating_types:[ { label: '', id: 0, unity:'' },
        { label: this.$t('oil'), id: 1, unity:this.$t('l')},
        { label: this.$t('gaz'), id: 2, unity:this.$t('kWh')},
        { label: this.$t('wood'), id: 3, unity:this.$t('m3') },
        { label: this.$t('electricity'), id: 4, unity:this.$t('kWh')}
      ],
      heating_type:'',
      mybuilding_heating_type:true,
      mybuilding_heating_type_button:true,
      mybuilding_heating_type_text:'',
      mybuilding_heating_type_visible:false,


      myconsumption:'', 
      mybuilding_consumption: true,
      mybuilding_consumption_button:true,
      mybuilding_consumption_text:'',
      mybuilding_consumption_visible:false,
      heating_unit_label: '',
      mybuilding_consumption_from_client:false,

      
      mybuilding_boiler_button:true, 
      mybuilding_boiler: true,
      mybuilding_boiler_text:'',       
      mybuilding_boiler_visible:false,

      mycalculation: true,
      mycalculation_already_opened: false,
      mybuilding_status: '0/2',
      myconsumption_status: '',
      current_consumption: false,
      current_consumption_value: '',
      estimated_consumption_value: '',
      estimated_consumption_value_formatted: '',
      description: '',
      title: '',
      boiler: false,
      boiler_type: 0,
      panels:[0],
      panels2:[],
      show: false,

      showco2: false,
      showmaintenance: false,

      email: '',
      email_confirm: '',
      remember: false,
      heat_pump:false,
      password: '',
      password_confirm: '',
      disponibility: '',
      staticURL:'',
      cad_co2_value: 0,
      co2_value: 0,
      connection_contribution: 0,
      costs_price_75: 0,
      costs_price_80: 0,
      costs_price_90: 0,
      costs_price_100: 0,
      current_costs: 0,
      power: 0,
      power_contribution: 0,
      price_75: 0,
      price_90: 0,
      price_80: 0,
      price_100: 0,
      promotion: 0,
      re_consumption: 0,
      sponsoring: 0,
      th_consumption: 0,
      total_av_consumption: 0,
      total_connection_costs: 0,
      saving_maintenance_costs: 0,
      c02_sparing: 0,
      lc_data : {},
      lc_output : {},
      last_calculation : false,
      calculated: false,
      annual_estimated_cost_75: 0,
      annual_estimated_cost_80: 0,
      annual_estimated_cost_90: 0,
      annual_estimated_cost_100: 0,
      rules: {
          required: value => !!value || this.$t('mandatory'),
          min: v => v.length >= 8 || this.$t('password_hint'),
          emailMatch: () => (this.$t('mail_confirm_error')),
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || this.$t('invalid_email')}
      },
    }
  },
  props: [ 'showQuoteRequestDialog' ],
  computed: {
  },
  methods: {
    moveTo(target){
       setTimeout(() => {
      
      var container = document.querySelector(".calculator-dialog")
      var dccc = document.getElementById(target)
      if (dccc) {
        container.scrollTo(0, dccc.offsetTop+90)
        console.log("move to: "+(dccc.offsetTop+90))
      }
       },300)
    },
    openPanel(n){
      setTimeout(() => {this.panels=n}, 100)
    },
    openMyBuilding(){
      this.myaddress = false
      this.mybuilding_visible = true
      this.mybuilding = false
      this.openPanel(1)
      this.moveTo('mybuilding')
    },
    onBuildingSize (size) {
      this.building_size = size
      this.isHouse = size === 'house'
      this.isBuilding = size === 'building'
      this.isCompany= size === 'company'
      if (size  === 'house' )
        this.mybuilding_text = this.$t('house')
      if (size  === 'building' )
        this.mybuilding_text = this.$t('building')
      if (size  === 'company' )
        this.mybuilding_text = this.$t('company')
      this.sizeNotChoosen = !(this.isHouse || this.isBuilding || this.isCompany)
      if (!this.sizeNotChoosen){
            this.mybuilding_button = false
      }else{
        this.mybuilding_button = true
      }
    },
    openMyBuildingType(){
      this.myaddress = false
      this.mybuilding = false
      this.mybuilding_type = false
      this.mybuilding_type_button = true
      this.mybuilding_type_visible = true
      this.panels = 1
      this.moveTo('mybuildingtype')
      this.mybuilding_type_event()
    },
    mybuilding_type_event(){
      if (this.building_type == 'new'){
        this.building_date = ''
        this.renovation = false
        this.renovation_date = false
        this.renovation_type = ''
        this.mybuilding_consumption_from_client = false
        this.mybuilding_type_text = this.$t('new')
        this.mybuilding_type_button = false
        if (this.mybuilding_heating_type_visible){
          this.mybuilding_heating_type = true
          this.mybuilding_heating_type_text = ''
          this.heating_type = ''
          this.mybuilding_heating_type_button = true
        }
        if (this.mybuilding_consumption_visible){
          this.mybuilding_consumption = true
          this.mybuilding_consumption_text = ''
          this.current_consumption_value = ''
          this.myconsumption_button = true
          this.mybuilding_consumption_from_client = false
        }
        if (this.mybuilding_renovation_visible){
          this.mybuilding_renovation_text = ''
          this.mybuilding_renovation = true
          this.mybuilding_renovation_button = true
          this.renovation_type = ''
        }
        return
      }else{
        if (this.building_type == 'existing' && this.building_date > 1200){        
          this.mybuilding_type_button = false
          this.mybuilding_type_text = this.$t('existing')+': '+this.building_date
          return
        }else{
          this.mybuilding_type_button = true

        }
      }
    },
    openMyBuildingRenovation(){
        this.mybuilding_renovation_visible = true
      if (this.building_type == 'existing'){
        this.myaddress = false
        this.mybuilding = false
        this.mybuilding_type = false
        this.mybuilding_type_button = false
        this.mybuilding_renovation = false
        this.mybuilding_renovation_error =''
        this.panels = 2
        this.renovation_type = 0
        this.moveTo('mybuildingrenovation')
        this.mybuilding_event_renovation()
      }else{
        this.mybuilding_renovation = true
        this.mybuilding_renovation_text = ''
        this.openMyBuildingArea()
      }
    },
    mybuilding_event_renovation_delayed(){
      setTimeout(() => {this.mybuilding_event_renovation()}, 500)
    },
    mybuilding_event_renovation(){
      if (this.renovation){
        if (this.renovation_date > 1200 && this.renovation_type > -1){
          if (this.renovation_date < this.building_date){
            this.mybuilding_renovation_error = this.$t('renovation_date_error')
            this.mybuilding_renovation_button = true
            this.mybuilding_renovation_text = ""
          }else{
            this.mybuilding_renovation_error =''
            this.mybuilding_renovation_text = this.renovation_types[this.renovation_type]['value'] + " "+this.$t('in')+" "+this.renovation_date
            this.mybuilding_renovation_button = false
          }
          return
        }else{
          this.mybuilding_renovation_button = true
          this.mybuilding_renovation_text = ""
        }
      }else{
        this.mybuilding_renovation_text = this.$t('no')
        this.mybuilding_renovation_button = false
        
        return
      }
    },
    openMyBuildingArea(){      
      this.mybuilding_area = false
      this.mybuilding_area_button = true
      this.mybuilding_area_text = ''
      this.mybuilding_area_visible = true
      this.panels = 3
      this.moveTo('mybuildingarea')
      this.mybuilding_event_area()
    },
    mybuilding_event_area(){
      if (this.living_area > 0){
        this.mybuilding_area_button = false
        this.mybuilding_area_text = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(this.living_area).replace(' ',"'") + ' '+this.$t('m2')
      }else{
        this.mybuilding_area_button = true
      }
    },
    openMyHeatingType(){
      if (this.mybuilding_area_button)
        return
      this.mybuilding_heating_type_text = ''
      this.mybuilding_heating_type_visible = true

      if (this.building_type == 'existing'){
        this.mybuilding_heating_type =  false
        this.mybuilding_heating_type_button = true
        this.panels = 4
        this.moveTo('mybuildingheatingtype')
      }else{
        this.heating_type = ''
        this.mybuilding_heating_type =  true
        this.mybuilding_heating_type_button = true
        this.openMyBuildingBoiler()
        return
      }

    },
    onHeatingType(type) {
      if (type != this.heating_type){
        this.mybuilding_boiler = true
        this.mybuilding_consumption = true
        this.mybuilding_consumption_text = ''
        this.current_consumption_value = 0        
      }
      this.heating_type = type
      this.mybuilding_heating_type_text = this.heating_types[type]['label']
      this.heating_unit = this.heating_types[type]['unity']
      this.mybuilding_heating_type_button = false
    },

    openMyBuildingBoiler(){
      this.mybuilding_boiler = false
      this.mybuilding_boiler_visible = true
      this.panels = 5
      this.moveTo('mybuildingboiler')
    },

    onBoilerType(type) {
      this.boiler_type = type
      this.boiler = false
      if (this.boiler_type == 1){
        this.boiler = true
        this.mybuilding_boiler_text = this.$t('electric')
      }else{
        this.mybuilding_boiler_text = this.$t('with_heating')
      }
      this.mybuilding_boiler_button=false
    },
    openMyBuildingConsumption(){
      this.mybuilding_consumption_visible = true
      if (this.building_type == 'existing'){
        this.mybuilding_consumption = false
        this.moveTo('mybuildingconsumption')

      }else{
        this.mybuilding_consumption = true
        this.openMyBuildingBoiler()
        return

      }
      this.current_consumption_value = 0
      this.mybuilding_consumption_from_client = false
      var data = {}
      data['token'] = this.$store.userToken
      data['lng'] = this.$store.position[0]
      data['lat'] = this.$store.position[1]
      data['lang'] = this.$store.lang
      data['address'] = this.$store.searchedAddressText
      data['zone'] = this.$store.mapZone
      data['zone_text'] = this.$store.mapZones[this.$store.mapZone].name
      data['description'] = this.$store.mapZones[this.$store.mapZone].description
      data['disponibility'] = this.$store.mapZones[this.$store.mapZone].disponibility
      data['building_type'] = this.building_type
      data['building_size'] = this.building_size
      data['building_date'] = this.building_date
      data['renovation'] = this.renovation
      data['renovation_date'] = this.renovation_date
      data['renovation_type'] = this.renovation_type
      data['living_area'] = this.living_area
      data['heating_type'] = this.heating_type
      data['heat_pump'] = this.heat_pump
      data['current_consumption_value'] = this.current_consumption_value
      data['consumption_from_client'] = this.mybuilding_consumption_from_client
      data['boiler'] = this.boiler
      axios.post(this.$store.backendAPI+'calculate/', data)
      .then(response => {
        if (response.status == 200){
          if (response.data.total_th_consumption)
            this.estimated_consumption_value = response.data.total_th_consumption
            this.current_consumption_value = this.estimated_consumption_value
            this.estimated_consumption_value_formatted = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(this.estimated_consumption_value).replace(' ',"'")+' '+this.heating_unit+this.$t('/an')
            this.mybuilding_consumption_button = false
            this.heating_unit_label =  this.$t('your_annual_consumption_in')+' '+ this.heating_unit+this.$t('/an')
          }
          this.consumption = ''
          this.panels = 6
          this. myconsumption_event()

         })
      .catch(e => {
        console.log(e)         
        this.consumption = ''
        this.mybuilding_consumption =  false
        this.mybuilding_consumption_button = false
        this.mybuilding_consumption_text = ''
        this.panels = 6
        this. myconsumption_event()
      })
      
    },
    myconsumption_event(){
      if (this.current_consumption_value > 0){
        this.mybuilding_consumption_button = false
        // this.mybuilding_consumption_text = this.current_consumption_value+' '+this.heating_unit
        this.mybuilding_consumption_text = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(this.current_consumption_value).replace(' ',"'")+' '+this.heating_unit+this.$t('/an')
        if (this.current_consumption_value != this.estimated_consumption_value){
          this.mybuilding_consumption_from_client = true
        }else{
          this.mybuilding_consumption_from_client = false
        }
      }else{
        this.mybuilding_consumption_button = true
      }
    },
    openMyCalculation(){

      if (this.mybuilding_consumption_button && this.building_type == 'existing')
        return
      var data = {}
      data['token'] = this.$store.userToken
      data['lng'] = this.$store.position[0]
      data['lat'] = this.$store.position[1]
      data['address'] = this.$store.searchedAddressText
      data['zone'] = this.$store.mapZone
      data['zone_text'] = this.$store.mapZones[this.$store.mapZone].name
      data['zone_id'] = this.$store.mapZones[this.$store.mapZone].id
      data['description'] = this.$store.mapZones[this.$store.mapZone].description
      data['disponibility'] = this.$store.mapZones[this.$store.mapZone].disponibility
      data['building_type'] = this.building_type
      data['building_size'] = this.building_size
      data['building_date'] = this.building_date
      data['renovation'] = this.renovation
      data['heating_type_text'] = this.heating_type_text
      data['building_type_text'] = this.building_type_text
      data['renovation_text'] = this.renovation_text
      data['renovation_date'] = this.renovation_date
      data['renovation_type'] = this.renovation_type
      data['living_area'] = this.living_area
      data['heating_type'] = this.heating_type
      data['heat_pump'] = this.heat_pump
      data['current_consumption_value'] = this.current_consumption_value
      data['consumption_from_client'] = this.mybuilding_consumption_from_client
      data['boiler'] = this.boiler
      data['PDF'] = true
      data['lang'] = this.$store.lang
      data['map'] = ''
      if (this.$store.mapParameters && this.$store.mapParameters.hash){
          data['map'] = this.$store.mapParameters.hash
      }
      this.loading = true
      axios.post(this.$store.backendAPI+'calculate/', data)
      .then(response => {
        if (response.status == 200){
          this.$store.calculation = response.data
          this.mycalculation = false
          this.cad_co2_value = response.data.cad_co2_value
          this.co2_value = response.data.co2_value
          this.connection_contribution = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(response.data.connection_contribution).replace(' ',"'")
          this.costs_price_75 = response.data.costs_price_75
          this.costs_price_80 = response.data.costs_price_80
          this.costs_price_90 = response.data.costs_price_90
          this.costs_price_100 = response.data.costs_price_100
          this.current_costs = response.data.current_costs
          this.power = response.data.power
          this.power_contribution = response.data.power_contribution
          this.price_75 = response.data.price_75
          this.price_80 = response.data.price_80
          this.price_90 = response.data.price_90
          this.price_100 = response.data.price_100
          this.promotion = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(response.data.promotion).replace(' ',"'")
          this.re_consumption = response.data.re_consumption
          this.sponsoring = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(response.data.sponsoring).replace(' ',"'")
          this.th_consumption = response.data.th_consumption
          this.total_av_consumption = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(response.data.total_av_consumption).replace(' ',"'")
          this.c02_sparing =  new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(response.data.co2_value - response.data.cad_co2_value).replace(' ',"'")
          this.saving_maintenance_costs = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(response.data.saving_maintenance_costs).replace(' ',"'")
          this.pdf_url = response.data.pdf
          this.annual_estimated_cost_75 = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(response.data.estimated_costs_75).replace(' ',"'")
          this.annual_estimated_cost_80 = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(response.data.estimated_costs_80).replace(' ',"'")
          this.annual_estimated_cost_90 = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(response.data.estimated_costs_90).replace(' ',"'")
          this.annual_estimated_cost_100 = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(response.data.estimated_costs_100).replace(' ',"'")
          this.panels2 = 0
          this.panels = ''
          this.total_connection_costs = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(response.data.connection_contribution - response.data.promotion - response.data.sponsoring).replace(' ',"'")
          this.mycalculation_already_opened = true
          this.loading = false
          this.calculated = true
          if (this.building_type == 'existing'){
          this.showco2= false
          if (response.data.co2_value> 0)
            this.showco2= true
          this.showmaintenance= false
          if (response.data.saving_maintenance_costs > 0)
            this.showmaintenance= true
          this.chartDataCO2= {
              hoverBorderWidth: 10,
              labels: [this.$t('sparing_co2_year'), this.mybuilding_heating_type_text ],
              datasets: [
                {
                  label: "Data One",
                  backgroundColor: ["#72A62D", "#C1C1C1"],
                  data: [(response.data.co2_value - response.data.cad_co2_value),response.data.co2_value]
                }
              ]
            }
          }

          if (this.$store.lastCalculationMarker){
            if (this.$store.lastCalculation.lng != this.$store.position[0] &&  this.$store.lastCalculation.lat != this.$store.position[0]){
              this.$store.lastCalculationMarker.remove()
            }
          }
        }else{
          this.showco2= false
          this.showmaintenance= false

        }
        setTimeout(() => {
          var container = document.querySelector(".calculator-dialog")
          var dccc= document.querySelector(".calculation")
          if (dccc) {
            container.scrollTo(0, dccc.offsetTop+30)
            console.log("move to: "+(dccc.offsetTop+30))
          }
      
        },300)

         })
      .catch(e => {
        console.log(e)
         this.error = 'error'
         this.loading = false
      })
    },
    initValues(){
      this.myaddress = false
      this.myaddress_status = ''
      this.calculated = false

      this.mybuilding_visible = true
      this.mybuilding_type_visible = false
      this.mybuilding_renovation_visible = false
      this.mybuilding_area_visible = false
      this.mybuilding_heating_type_visible = false
      this.mybuilding_consumption_visible = false
      this.mybuilding_boiler_visible = false

      this.mybuilding = false
      this.building_size = ''
      this.isHouse = false
      this.isBuilding = false
      this.isCompany = false
      this.sizeNotChoosen = false
      this.mybuilding_button = true


      this.mybuilding_type= true
      this.building_type= ''
      this.mybuilding_type_button=false
      this.mybuilding_type_text=''

      this.mybuilding_renovation_text=''
      this.mybuilding_renovation_button=true
      this.mybuilding_renovation=true
      this.renovation=false
      this.renovation_date=null
      this.renovation_type=''
      this.mybuilding_renovation_error=''

      this.mybuilding_area = true
      this.mybuilding_area_button = true
      this.mybuilding_area_text = ''
      this.living_area =  null

      this.heating_type = ''
      this.mybuilding_heating_type =  true
      this.mybuilding_heating_type_button = true
      this.mybuilding_heating_type_text = ''

      this.consumption = ''
      this.mybuilding_consumption =  true
      this.mybuilding_consumptiont_button = true
      this.mybuilding_consumption_text = ''

      this.mybuilding_boiler_button=true
      this.mybuilding_boiler= true
      this.mybuilding_boiler_text=''
      this.boiler_type = 0

      this.myconsumption_button = true
      this.myconsumption = true
      this.myconsumption_already_opened = false

      this.mycalculation = true
      this.mycalculation_already_opened = false
      this.current_consumption = false
      this.current_consumption_value = ''
      this.estimated_consumption_value = ''
      this.description = ''
      this.title = ''
      this.building_date = null
      this.renovation = false
      this.renovation_date = null
      this.renovation_type = ''
      this.heating_type = ''
      this.heating_unit = ''     
      this.boiler = false
      this.panels = 0
      this.panels2 = []
      this.show = false
      this.email = ''
      this.email_confirm = ''
      this.remember = false
      this.heat_pump = false
      this.password = ''
      this.password_confirm = ''
      this.disponibility = ''
      this.staticURL = ''
      this.cad_co2_value = 0
      this.co2_value = 0
      this.connection_contribution = 0
      this.costs_price_75 = 0
      this.costs_price_80 = 0
      this.costs_price_90 = 0
      this.costs_price_100 = 0
      this.current_costs = 0
      this.power = 0
      this.power_contribution = 0
      this.price_75 = 0
      this.price_80 = 0
      this.price_90 = 0
      this.price_100 = 0
      this.promotion = 0
      this.re_consumption = 0
      this.sponsoring = 0
      this.th_consumption = 0
      this.total_av_consumption = 0
      this.total_connection_costs = 0
      this.saving_maintenance_costs = 0
      this.c02_sparing = 0
      this.annual_estimated_cost_75 = 0
      this.annual_estimated_cost_80 = 0
      this.annual_estimated_cost_100 = 0
      this.estimated_consumption_value_formatted = ''
      this.showco2= false
      this.showmaintenance= false
      this.lc_data = {}
      this.lc_output = {}
      this.last_calculation = false
      this.mybuilding_consumption_from_client = false
    },
    back() {
      return true
    },
    openDialog(){
      this.initValues()
      if (this.$store.mapZone){
        this.title = this.$store.mapZones[this.$store.mapZone].name
        this.description = this.$store.mapZones[this.$store.mapZone].description
        this.disponibility = this.$store.mapZones[this.$store.mapZone].disponibility
        this.staticURL = 'https://api.mapbox.com/styles/v1/notil/ck7np2rrb0mg41imkry1w1o2o/static/'+this.$store.position[0]+','+this.$store.position[1]+',15/400x200?access_token=pk.eyJ1Ijoibm90aWwiLCJhIjoiY2p2MmhjenhkMTNibzN6a2N1cWRzZmYyciJ9.OJOYbGff0Z2qUSx5jCn5eQ'
        // this.myaddress_status = this.$store.searchedAddressText
      }else{
      this.description = ''
      this.disponibility = ''
      }
      var data = {}      
      data['token'] = this.$store.userToken
      data['address'] = this.$store.searchedAddressText 
     
      this.dialog = true
      this.openPanel(0)
    },
    openExisitingCalculation(data){
      // input panel
      this.title = data['zone']
      this.description = ''
      this.disponibility = ''
      this.staticURL = 'https://api.mapbox.com/styles/v1/notil/ck7np2rrb0mg41imkry1w1o2o/static/'+data['lng']+','+data['lat']+',15/400x200?access_token=pk.eyJ1Ijoibm90aWwiLCJhIjoiY2p2MmhjenhkMTNibzN6a2N1cWRzZmYyciJ9.OJOYbGff0Z2qUSx5jCn5eQ'


      // Calculation panel
      this.mycalculation = false

      this.mybuilding_consumption_from_client = data['consumption_from_client']
      this.$store.searchedAddressText = data.address
      this.$store.position = [data['lng'],data['lat']]
      this.$store.mapZone = data.zone
      this.$store.calculation = data
      this.cad_co2_value = data.cad_co2_value
      this.co2_value = data.co2_value
      this.connection_contribution = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(data.connection_contribution).replace(' ',"'")
      this.costs_price_75 = data.costs_price_75
      this.costs_price_80 = data.costs_price_80
      this.costs_price_90 = data.costs_price_90
      this.costs_price_100 = data.costs_price_100
      this.current_costs = data.current_costs
      this.power = data.power
      this.power_contribution = data.power_contribution
      this.price_75 = data.price_75
      this.price_80 = data.price_80
      this.price_90 = data.price_90
      this.price_100 = data.price_100

      this.annual_estimated_cost_75 = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(data.estimated_costs_75).replace(' ',"'")
      this.annual_estimated_cost_80 = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(data.estimated_costs_80).replace(' ',"'")
      this.annual_estimated_cost_90 = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(data.estimated_costs_90).replace(' ',"'")
      this.annual_estimated_cost_100 = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(data.estimated_costs_100).replace(' ',"'")
      this.promotion = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(data.promotion).replace(' ',"'")
      this.re_consumption = data.re_consumption
      this.sponsoring = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(data.sponsoring).replace(' ',"'")
      this.th_consumption = data.th_consumption
      this.total_av_consumption = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(data.total_av_consumption).replace(' ',"'")
      this.c02_sparing =  new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(data.co2_value - data.cad_co2_value).replace(' ',"'")
      this.saving_maintenance_costs = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(data.saving_maintenance_costs).replace(' ',"'")
      this.pdf_url = data.pdf
      this.panels2 = 0
      this.panels = ''
      this.total_connection_costs = new Intl.NumberFormat('fr-CH', { style: 'decimal' }).format(data.connection_contribution - data.promotion - data.sponsoring).replace(' ',"'")
      this.mycalculation_already_opened = true
      this.loading = false
      this.calculated = true

      this.mybuilding_visible = true
      this.mybuilding = false
      this.building_size = data.building_size
      this.onBuildingSize(this.building_size)

      this.mybuilding_type_visible = true
      this.mybuilding_type = false
      this.building_type = data.building_type      
      this.building_date = data.building_date
      this.mybuilding_type_event()

      this.renovation_type = data.renovation_type
      this.renovation = data.renovation
      this.renovation_date = data.renovation_date
      this.mybuilding_renovation_visible = true
      this.mybuilding_event_renovation()
      if (this.renovation){
       this.mybuilding_renovation = false
      }

      this.living_area = parseInt(data.living_area)
      this.mybuilding_area_visible = true
      this.mybuilding_area = false
      this.mybuilding_event_area()

      this.mybuilding_heating_type_visible = true
      this.heating_type = data.heating_type
      if (this.heating_type == 5){
        this.heating_type = ''
        this.mybuilding_heating_type_text = ''
      }else{
        this.mybuilding_heating_type = false
        this.onHeatingType(this.heating_type)

      }

      
      this.mybuilding_boiler = data.boiler
      this.mybuilding_boiler_visible = true
      this.mybuilding_boiler = false
      if (this.mybuilding_boiler){
        this.boiler_type = 1
      }else{
        this.boiler_type = 2
      }
      this.onBoilerType(this.boiler_type)
      if (this.building_type == 'existing'){
      this.openMyBuildingConsumption()
       setTimeout(() => {
      this.current_consumption_value = data.current_consumption_value
      this.myconsumption_event()

      this.panels = 6


       }, 400)
      }else{
         setTimeout(() => {
        this.panels = 5
       }, 400)
      }


      if (this.building_type == 'existing'){
        this.showco2= false
        if (data.co2_value> 0)
          this.showco2= true
        this.showmaintenance= false
        if (data.saving_maintenance_costs > 0)
          this.showmaintenance= true
      }else{
        this.showco2= false
        this.showmaintenance= false

      }

    },
    closeDialog(){
      this.dialog = false
    },
    toggleDialog(){
      this.dialog = !this.dialog
    }
  }

}
</script>

